import { pathJoin } from 'src/reducers/routing/utils'

export const createDataSyncRoutesMap = (prefix: string) => ({
  'master-data-sync': pathJoin(prefix)('master-data-sync').chain,
  'debtor-data-sync': pathJoin(prefix)('debtor-data-sync').chain,
})
